<template>
  <div class="success-container">
    <div class="vcore_container pe_container">
      <div class="vcore_row">
        <div class="vcore_col--xs--12 form-container_provider-logo">
          <LogoDisplay v-if="logo" :logo-src="logo"></LogoDisplay>
        </div>
        <div class="vcore_col--xs--12">
          <h2 class="form-title" tabindex="-1" v-focus>
            {{ formData.pageTitle }}
          </h2>
          <div class="form-description">
            {{ formData.pageDescription }}
          </div>
        </div>
        <div class="vcore_col--xs--12">
          <PaymentEstimator
            :total-loan-amount="amountRequested | usdToFloat"
            :terms="selectedProvider.terms"
            :is-fixed-rate="selectedProvider.isFixedRate"
            :fixed-interest-rate="selectedProvider.fixedInterestRate"
            :rate-margin="selectedProvider.rateMargin"
            :step="'Success'"
            readonly
          ></PaymentEstimator>
        </div>
        <div class="vcore_col--xs--12">
          <section
            v-for="section in formData.sections"
            :key="section.sectionTitle"
          >
            <div class="success_section_title">{{ section.sectionTitle }}</div>
            <div class="success_section_description">
              {{ section.sectionDescription }}
            </div>
            <ul
              v-if="section.sectionList.length > 0"
              class="success_section_list"
            >
              <li
                v-for="item in section.sectionList"
                :key="item"
                class="success_section_list-item"
              >
                {{ item }}
              </li>
            </ul>
          </section>
        </div>
        <div v-if="selectedProvider.selfEnrShowPhoneNum" class="vcore_col--xs--12 success_section_contact">
          In the meantime if you have any questions concerning this enrollment,
          contact {{ selectedProvider.providerName }} at
          <a
            class="vcore_link"
            :href="`tel:${selectedProvider.billingContactPhone}`"
            >{{ selectedProvider.billingContactPhone }}</a
          >.
        </div>
        <div v-else class="vcore_col--xs--12 success_section_contact">
          In the meantime if you have any questions concerning this enrollment,
          contact {{ selectedProvider.providerName }}.
        </div>
        <div class="vcore_col--xs--12 success_section_final">
          You may close this browser window.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SuccessNonAuthForm from "../../forms/SuccessNonAuth.json";
import PaymentEstimator from "@Shared/components/PaymentEstimator";
import LogoDisplay from "../LogoDisplay";
import { KEYS, getCustomBrandingByKey } from "@Shared/utils/CustomBranding";
import { mapGetters } from "vuex";

export default {
  name: "Success",
  components: { PaymentEstimator, LogoDisplay },
  data() {
    return {
      formData: SuccessNonAuthForm,
      lastActivated: "",
    };
  },
  activated() {
    this.lastActivated = +new Date();
  },
  computed: {
    ...mapGetters(["amountRequested", "selectedProvider"]),
    logo() {
      return getCustomBrandingByKey(
        KEYS.LOGO,
        this.selectedProvider.customBrandingList
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.success_section_title {
  font-size: 21px;
  margin: 40px 0 15px;
  line-height: 25px;
  font-family: "Poppins";
  color: #43454d;
  font-weight: 500;
}

.success_section_description {
  line-height: 20px;
}

.success_section_list {
  line-height: 22px;
  list-style: initial;
  padding-left: 40px;
  padding-top: 5px;
  padding-bottom: 5px;

  // .success_section_list-item {
  // }
}

.success_section_contact,
.success_section_final {
  margin-top: 30px;
}

.payment-estimator {
  margin-top: 40px;
}
</style>
